import { gql } from 'graphql-tag';
import { useContext } from 'react';
import { useEventYearFilter } from 'components/YearDropdown';
import { usePersistedQuery } from 'hooks/usePersistedQuery';
import { useSearchInput } from 'hooks/useSearchInput';
import { AppContext } from 'shared/AppContext';

export const GET_TRACK_REEDEMED_CREDITS = gql`
  query GetTrackredeemedCredits($creditsInput: GetTrackCreditsInput!) {
    getTrackRedeemedCredits(input: $creditsInput) {
      count
      results {
        id
        formatted_name
      }
    }
  }
`;

export function useGetTrackRedeemedCredits() {
  const { yearFilter } = useEventYearFilter();
  const { input: search } = useSearchInput();
  const {
    state: { accountId },
  } = useContext(AppContext);

  const result = usePersistedQuery(
    GET_TRACK_REEDEMED_CREDITS,
    `track-redeemed-credits-${accountId}`,
    {
      variables: {
        creditsInput: {
          ...(yearFilter ? { year: yearFilter } : null),
          ...search,
          ...{ account_id: accountId },
        },
      },
      fetchPolicy: 'cache-and-network',
    }
  );

  return { ...result, resRedeemed: result.data };
}
